import { Box, IconButton, Skeleton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

export default function CouponFormSkeleton() {
  const navigate = useNavigate();

  return (
    <Box>
      {/* Fixed Header Skeleton */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Skeleton variant='text' width={200} height={32} />
        <IconButton onClick={() => navigate(-1)} size='small'>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Form with Fixed Footer */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Scrollable Content Skeleton */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3,
            position: 'relative',
            zIndex: 1
          }}
        >
          {Array.from({ length: 7 }, (_, index) => (
            <Box key={`form-field-${index}`} sx={{ mb: 3 }}>
              <Skeleton variant='text' width={150} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} />
            </Box>
          ))}
        </Box>

        {/* Fixed Footer Skeleton */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid #DEDEDE',
            display: 'flex',
            justifyContent: 'end',
            gap: '16px',
            flexShrink: 0
          }}
        >
          <Skeleton variant='rectangular' width={80} height={36} />
          <Skeleton variant='rectangular' width={80} height={36} />
        </Box>
      </Box>
    </Box>
  );
}
